/**
 * Calculate a contrasting foreground color (black or white) for a given background color.
 * Uses luminance-based calculation per ITU-R BT.601.
 */
export function getContrastingColor(backgroundColor: string): string {
  if (!backgroundColor || backgroundColor === 'transparent') {
    return '#000000';
  }

  if (backgroundColor.toLowerCase() === '#ffffff' || backgroundColor.toLowerCase() === '#f2e6ff') {
    return '#000000';
  }

  const hex = backgroundColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.6 ? '#000000' : '#ffffff';
}
